module.exports = __webpack_public_path__ + "static/media/layout.ce7b4c3c.svg";